import ApiClient from '@/api/ApiClient';

import type {
  FilterCriteria,
  PagedResultUserListItem,
  SortCriteria,
  UserCountStatistics,
} from '../models';

export type GetUsersListRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export type GetHrUserStatisticsRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  groupBy?: string;
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export class HrUserListClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getUsersList(request: GetUsersListRequest = {}): Promise<PagedResultUserListItem> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/users',
      params,
    });
  }

  getHrUserStatistics(request: GetHrUserStatisticsRequest = {}): Promise<UserCountStatistics[]> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/users/statistics',
      params,
    });
  }

  exportUserWorkClothes(filter: string, request: GetUsersListRequest = {}): Promise<any> {
    return this.apiClient.getBlob({
      path: `/api/hr/users/work-clothes/export?${filter ?? ''}`,
      params: request,
    });
  }

  exportUserFamilyMembers(filter: string, request: GetUsersListRequest = {}): Promise<any> {
    return this.apiClient.getBlob({
      path: `/api/hr/users/family-members/export?${filter ?? ''}`,
      params: request,
    });
  }
}

export default HrUserListClient;
